import SaveIcon from "@mui/icons-material/Save";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Fade,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  InputLabel,
  List, ListItem, Button as MButton,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Switch,
  Tab, Tabs,
  Typography
} from "@mui/material";
import _, { get } from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { Responsive } from "react-grid-layout";
import toast from "react-hot-toast";
import { updateReportById } from "../../../config/services/reports";
import ReportGraph from "../../../pages/ReportGraph";
import CubeReqMapper from "../../../utils/CubeReqMapper";
import Limit from "../../common/Limit";
import Button from "../../controls/Button";
import Input from "../../controls/Input";
import FilterDateRange from "../cards/FilterDateRange";
import FilterMultipleSelectValue from "../cards/FilterMultipleSelectValue";
import FilterSelectValue from "../cards/FilterSelectValue";
import FilterSingleDate from "../cards/FilterSingleDate";

import { withStyles } from '@mui/styles';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import moment from "moment";
import { ReactComponent as GraphIcon } from "../../../assets/icons/graph-icon.svg";
import { ReactComponent as IconAngleDown } from "../../../assets/icons/icon-angle-down.svg";
import { ReactComponent as CancelIcon } from "../../../assets/icons/icon-cancel.svg";
import { ReactComponent as MoreIcon } from "../../../assets/icons/icon-more.svg";
import CloseIcon from "../../../assets/icons/icon_close.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icons/icon_filter.svg";
import { ReactComponent as ResizeIcon } from "../../../assets/icons/icon_resize.svg";
import { ReactComponent as TableIcon } from "../../../assets/icons/table-icon.svg";
import { COLORS_SERIES } from '../../../constants/chartColorSeries';
import { LimitAllowedIn } from "../../../constants/chartType";
import { CamelToNormalString, convertPivotConfig, formatOrderBy, generateCustomDateRange, isMobileView, mapLinkedResponseData } from "../../../utils/Reusables";
import { handleLanguageChange } from "../../../utils/multiLangDashboardV2Data";
import ChartEnlargeView from './ChartEnlargeView';
import ReportChartFiltersMenu from "./ReportChartFiltersMenu";
import ReportFilterMenu from "./ReportFilterMenu";
import ReportMenu from "./ReportMenu";

import { ReactComponent as EditIcon } from "../../../assets/icons/icon_edit.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/icon_trash.svg";
import { ReactComponent as DeleteLgIcon } from "../../../assets/icons/icon-delete-btn-lg.svg";

import { NumberChartDescriptionLength, NumberChartTitleLength, ReportCardDescriptionLength, ReportCardTitleLength } from "../../../constants/stringParams";
import { handleStringLength } from "../../../utils/multiLangDashboardV2Data";
import Slider from "react-slick";
import { CarouselNextArrow, CarouselPrevArrow } from "./../../../utils/Reusables";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/swiper.min.css'
import 'swiper/modules/navigation/navigation.min.css';
import { ReactComponent as RightNavIcon } from "../../../assets/icons/icon-angle-right-main.svg";
import { ReactComponent as LeftNavIcon } from "../../../assets/icons/icon-angle-left-main.svg";
import ExportReactCSV from "../../../utils/ExportCSV";

const styles = theme => ({
  tagsContainer: {
    position: '-webkit-sticky',
    position: 'sticky',
    top: 0,
    zIndex: 9,
  },
  tagsList: {
    display: 'flex',
    flexDirection: 'row',
    padding: 0,
  },
  reportMorePopover: {
    zIndex: '9999'
  }
});
class DashboardChartLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentBreakpoint: "lg",
      compactType: "horizontal",
      mounted: false,
      exportCsv: false,
      reportListPopup: false,
      tabReports: [],
      layouts: { lg: props?.initialLayout ?? [] },
      mainSelectedReports: props?.selectedReports?.length
        ? structuredClone(props?.selectedReports)
        : [],
      selectedReports: props?.selectedReports?.length
        ? props?.selectedReports
        : [],
      isPublishedDashboardView: this.props.isPublishedDashboardView,
      isTitlePopup: {},
      measureTitle: this.mapMeasureReportsTitle(this?.props?.selectedReports)
        || {},
      dimensionTitle: this.mapDimensionReportsTitle(this?.props?.selectedReports)
        || {},
      enlargeViewObj: {},
      openEnlargeViewPopup: false,
      reportMoreMenuEl: null,
      reportMoreMenuId: null,
      renewCache: this.props.renewCache,
      toggledToTable: {},
      reportsTabsView: {},
      deleteSectionModalStatus: false,
      sectionModals: [],
      chartContainerWidth: null,
      isOpenSidebar: props?.isOpenSidebar ?? true,
      chartRefs: [],
      chartFilterRefs: [],
      isSheetToggled: false
    };
    this.fetchMeasureListByDatasetId = this.props.fetchMeasureListByDatasetId
    this.measureListByDataset = this.props.measureListByDataset
    this.onBreakpointChange = this.onBreakpointChange.bind(this);
    this.chartSlider = React.createRef(null);
    this.chartContainerRef = React.createRef(null);

  }

  onAccordianChange = (e) => {
    e.stopPropagation()
  }

  updateReport = (report, reportIndex) => {
    // update sheet
    let selectedReports = this.state.selectedReports
    const selecteReportIndex = selectedReports.findIndex(_report => _report._id === report._id);
    if (selecteReportIndex > -1) {
      selectedReports[selecteReportIndex] = { ...report };
    }
    this.setState({ selectedReports });
  }

  componentDidMount() {
    this.setState({ mounted: true });
    if (this.chartContainerRef && this.chartContainerRef.current) {
      this.setState({ chartContainerWidth: this.chartContainerRef.current.clientWidth });
    }

    var refsList = [];
    const layoutReports = this.generateLayout(this.props?.selectedReports);
    if (layoutReports?.length > 0) {
      refsList = Array(layoutReports?.length).fill().map((_, i) => refsList[i] || React.createRef());
      this.setState({ chartRefs: refsList })
    }

    var filtersRefsList = [];
    if (layoutReports?.length > 0) {
      filtersRefsList = Array(layoutReports?.length).fill().map((_, i) => filtersRefsList[i] || React.createRef());
      this.setState({ chartFilterRefs: filtersRefsList })
    }
  }

  handleReportBackgroundState = (val) => {
    if (!this.state.reportHasBackground) {
      this.setState({ reportHasBackground: val });
    }
  }

  applyFilterOnLinkedReports = async (report) => {
    let { linkedReports, reportFilters } = report;
    reportFilters = reportFilters?.filter((filter) => filter?.listType);
    if (!linkedReports?.length || !reportFilters.length) return report;
    report.linkedReports = await Promise.all(linkedReports.map(async (linkedReport) => {
      let { reportId } = linkedReport;
      let datasetMesureList = this.measureListByDataset[reportId?.dataSetId] || await this.fetchMeasureListByDatasetId(reportId?.dataSetId);
      await reportFilters.forEach((filter) => {
        let isMeasureAvailable = datasetMesureList.find((measure) => measure.name === filter.member.split('.')[1]);
        if (isMeasureAvailable) {
          const filterIndex = reportId.reportFilters.findIndex((reportFilter) => reportFilter.member.split('.')[1] === filter.member.split('.')[1]);
          if (filterIndex > -1) {
            const datasetName = (reportId?.measures?.[0]?.fieldName || reportId?.dimensions?.[0]?.fieldName)?.split('.')[0];
            reportId.reportFilters[filterIndex] = {
              ...reportId.reportFilters[filterIndex],
              ...filter,
              member: `${datasetName}.${filter.member.split('.')[1]}`,
            }
          } else {
            const datasetName = (reportId?.measures?.[0]?.fieldName || reportId?.dimensions?.[0]?.fieldName)?.split('.')[0];
            reportId.reportFilters = [...reportId.reportFilters, {
              ...filter,
              member: `${datasetName}.${filter.member.split('.')[1]}`,
              linkedReportFilter: true
            }]
          }
        }
      });
      return { ...linkedReport, reportId }
    }));
    return report;
  };

  componentDidUpdate(prevProps) {
    let { selectedReports } = this.props;
    let initialLayout = this.generateLayout(selectedReports);
    if (!(selectedReports == prevProps.selectedReports)) {
      this.setState({
        selectedReports: selectedReports,
        layouts: { lg: initialLayout ?? [] },
        measureTitle: this.mapMeasureReportsTitle(this?.props?.selectedReports) || {},
        dimensionTitle: this.mapDimensionReportsTitle(this?.props?.selectedReports) || {}
      });
    }
    if (!(this.props.renewCache == prevProps.renewCache)) {
      this.setState({
        renewCache: this.props.renewCache
      })
    }

    if (!(this.props.isOpenSidebar == prevProps.isOpenSidebar)) {
      this.setState({
        isOpenSidebar: this.props.isOpenSidebar
      });
      if (this.chartContainerRef && this.chartContainerRef.current) {
        this.setState({ chartContainerWidth: this.chartContainerRef.current.clientWidth });
      }
    }

    if (!(this.props?.selectedReports == prevProps?.selectedReports)) {
      this.setState({ isSheetToggled: !this.state.isSheetToggled })

      var refsList2 = [];
      const layoutReports2 = this.generateLayout(this.props?.selectedReports);
      if (layoutReports2?.length > 0) {
        refsList2 = Array(layoutReports2?.length).fill().map((_, i) => refsList2[i] || React.createRef());
        this.setState({ chartRefs: refsList2 })
      }

      var filtersRefsList2 = [];
      if (layoutReports2?.length > 0) {
        filtersRefsList2 = Array(layoutReports2?.length).fill().map((_, i) => filtersRefsList2[i] || React.createRef());
        this.setState({ chartFilterRefs: filtersRefsList2 })
      }
    }
  }

  updateFilterRefs = (i, ref) => {
    let currentFilterRefs = this.state.chartFilterRefs;
    if (ref && currentFilterRefs[i]) {
      currentFilterRefs[i].current = ref;
      this.setState({ chartFilterRefs: currentFilterRefs })
    }

  }

  mapMeasureReportsTitle = (data) => {
    let measureTitle = {};
    data?.forEach((report) => {
      let { _id } = report;
      if (typeof measureTitle[_id] !== "object") {
        measureTitle[_id] = {};
      }
      report?.measures?.map((meas) => {
        let { fieldName } = meas;
        measureTitle[_id][fieldName] = meas?.title;
      });
    });
    return measureTitle;
  };



  mapDimensionReportsTitle = (data) => {
    let dimensionTitle = {};
    data?.forEach((report) => {
      let { _id } = report;
      if (typeof dimensionTitle[_id] !== "object") {
        dimensionTitle[_id] = {};
      }
      report?.dimensions?.map((dim) => {
        let { fieldName } = dim;
        dimensionTitle[_id][fieldName] = dim?.title;
      });
    });

    return dimensionTitle;
  };

  handleReportLimit = (e, i) => {
    e.stopPropagation()
    let { value } = e.target;
    if (value < 1) {
      toast.error("Limit cannot be less than 1");
    } else {
      let { selectedReports } = this.props;
      selectedReports[i].limit = value;
      this.setState({ selectedReports: selectedReports });
    }
  };

  handleChangeFilterFromList = (obj, index, e, i) => {
    e.stopPropagation()
    e.target.value =
      typeof e.target.value === "string"
        ? e.target.value.split(",")
        : e.target.value;

    let { selectedReports } = this.props;

    selectedReports[i].reportFilters[index].values = e.target.value;
    this.setState({ selectedReports: selectedReports });
  };

  handleChangeDateFilterFromList = async (e, obj, i, dateType, reportIndex, currentReport) => {
    e.stopPropagation()
    let { selectedReports } = this.props;
    let value = e;
    const currentReportIndex = selectedReports?.findIndex(report => {
      return report?._id == currentReport?._id
    })
    if (moment(value).isValid()) {
      value = moment(value).format("YYYY-MM-DD HH:mm:ss")
    }
    else {
      value = ''
    }
    let newDates = [...obj.values]

    switch (dateType) {
      case 'startDate':
        newDates[0] = value
        break
      case 'endDate':
        newDates[1] = value
        break
      case 'singleDate':
        newDates[0] = value
        break
    }

    selectedReports[reportIndex].reportFilters[i].values = newDates;
    const report = await this.applyFilterOnLinkedReports(selectedReports[currentReportIndex]);
    selectedReports[currentReportIndex] = { ...report };
    this.setState({ selectedReports: selectedReports });
  };

  handleChangeDateFilterFromTimeperiod = async (selectedTimePeriod, filterIndex, reportIndex) => {
    let { selectedReports } = this.props;
    const { startDate, endDate } = generateCustomDateRange(selectedTimePeriod);
    selectedReports[reportIndex].reportFilters[filterIndex].dateFilterProps.selectedTimePeriod = selectedTimePeriod;
    selectedReports[reportIndex].reportFilters[filterIndex].values = [startDate, endDate];
    const report = await this.applyFilterOnLinkedReports(selectedReports[reportIndex]);
    selectedReports[reportIndex] = { ...report };
    this.setState({ selectedReports: selectedReports });
  }

  getValueListFromCube = (obj) => {
    if (obj.specificValue) return obj.valuesList;

    return [""];
  };

  handleMeasureTitleChange = (e, meas, l, i) => {
    e.stopPropagation()
    const { fieldName } = meas;
    if (typeof this.state.measureTitle[i] !== "object") {
      this.state.measureTitle[i] = {};
    }
    this.state.measureTitle[i][fieldName] = e.target.value;
    this.setState({ measureTitle: this?.state?.measureTitle });
  };

  handleDimensionTitleChange = (e, dim, l, i) => {
    e.stopPropagation()
    const { fieldName } = dim;
    if (typeof this.state.dimensionTitle[i] !== "object") {
      this.state.dimensionTitle[i] = {};
    }
    this.state.dimensionTitle[i][fieldName] = e.target.value;
    this.setState({ dimensionTitle: this?.state?.dimensionTitle });
  };

  handleLegendVisibility = (e, l, i) => {
    e.stopPropagation()
    let selectedReports = Array.from(this.state.selectedReports);
    let { checked } = e.target;
    selectedReports[i].isLegendVisible = checked;
    this.setState({ selectedReports });
  };

  handleLegendPosition = (e, l, i) => {
    e.stopPropagation()
    let selectedReports = Array.from(this.state.selectedReports);
    let { value } = e.target;
    selectedReports[i].legendPosition = value;
    this.setState({ selectedReports });
  };

  handleReportLinking = (e, l, i) => {
    e.stopPropagation()
    let selectedReports = Array.from(this.state?.selectedReports);
    let { value } = e?.target;
    const report = selectedReports.find(report => report?.reportName === value)
    selectedReports[i].linkedTo = {
      reportName: value,
      reportId: report?._id
    }
    this.setState({ selectedReports });
  }

  handleSaveTitle = async (e, l, i, index) => {
    e.stopPropagation()
    const measures = l?.measures?.map((meas) => {
      if (this?.state?.measureTitle[i]) {
        let title = this?.state?.measureTitle[i][meas?.fieldName];
        meas.title = title;
        return meas;
      } else {
        return meas;
      }
    });
    l.measures = measures;

    const dimensions = l?.dimensions?.map((dim) => {
      if (this?.state?.dimensionTitle[i]) {
        let title = this?.state?.dimensionTitle[i][dim?.fieldName];
        dim.title = title;
        return dim;
      } else {
        return dim;
      }
    });
    l.dimensions = dimensions;
    let { selectedReports } = this.props;

    selectedReports[index].measures = measures;
    selectedReports[index].dimensions = dimensions;

    this.setState({ selectedReports: selectedReports });

    let params = {
      reportId: selectedReports[index]?.reportId,
      measures: JSON.stringify(selectedReports[index]?.measures),
      dimensions: JSON.stringify(selectedReports[index]?.dimensions),
      isLegendVisible: selectedReports[index]?.isLegendVisible,
      legendPosition: selectedReports[index]?.legendPosition,
      linkedTo: selectedReports[index]?.linkedTo
    };

    return updateReportById(params).then((res) => {
      if (res?.result) {
        toast.success(res.message);
        this.toggleTitlePopup(e, false, i);
      } else if (res?.data?.statusCode === 0) {
        toast.error(res?.data?.error?.errorMessage);
      } else {
        console.error(res);
      }
    });
  };
  handleCLoseTitlePopup = (e, i) => {
    e.stopPropagation()
    const measureTitle = this.mapMeasureReportsTitle(
      this?.props?.selectedReports
    )
      ? this.mapMeasureReportsTitle(this?.props?.selectedReports)
      : {};
    const dimensionTitle = this.mapDimensionReportsTitle(
      this?.props?.selectedReports
    )
      ? this.mapDimensionReportsTitle(this?.props?.selectedReports)
      : {};
    this.setState({
      measureTitle: measureTitle,
      dimensionTitle: dimensionTitle,
    });
    this.toggleTitlePopup(e, false, i);
  };

  enlargeChart = (chartData) => {
    this.setState({ enlargeViewObj: chartData, openEnlargeViewPopup: true })
  }

  downloadReport = (report) => {
    if(report.linkedReports && report.linkedReports.length > 0 && report?.linkedReportsViewType == 'TAB'){
      let list = report.linkedReports.filter(obj => ['number','numberGraphicCard'].indexOf(obj?.reportId?.chartType) == -1).map(obj => { return {...obj.reportId,...obj}})
      list.unshift(report)
      this.setState({reportListPopup: true,reportObjToDownload: report, tabReports: list})
    }else{
      this.handleDowloadReportState(report)
    }
  } 

  handleCloseReportListPopup = () => {
    this.setState({reportListPopup: false,reportObjToDownload: null, tabReports: []})
  }

  handleExportReport = () => {
    this.handleDowloadReportState(this.state.reportObjToDownload)
  }

  handleSelectReport = (event) => {
    let id = event.target.value
    let report = this.state.tabReports.find(tab => tab._id === id)
    this.setState({reportObjToDownload: report})
  }

  handleDowloadReportState = (report) => {
    const pivotConfig = convertPivotConfig(report?.pivotConfig, report);
    const orderBy = formatOrderBy(report?.orderBy, report);
    report.pivotConfig = pivotConfig;
    report.orderBy = orderBy;
    report.noDataText = report?.noDataText || 'No Data'
    //report.reportHyperlink = report.reportHyperlink && report.reportHyperlink.length ? handleReportHyperLink(report) : [{ hyperlinkColumn: '', hyperlinkReportId: {}, hyperlinkFilters: [], hyperlinkType: '', hyperlinkExtType: '', hyperlinkExtParams: [], hyperlinkExtQryParams: [{ name: '', field: '' }] }]
    report.renewQuery = false
    report.linkedReports = mapLinkedResponseData(report)
    report.settings.conditionalFormat = report.settings.conditionalFormat || [{}]
    report.settings.pageSize = report.settings.pageSize || 10
    report.settings.xAxisLabelDegree = (report.settings.xAxisLabelDegree !== null && report.settings.xAxisLabelDegree !== undefined) ? report.settings.xAxisLabelDegree : 65;
    report.settings.alignment = report.settings.alignment || { header: 'left', dimensions: 'left' }
    report.settings.rateChangeProps = report.settings.rateChangeProps || {}
    report.settings.dataFormat = report.settings.dataFormat || {}
    report.settings.axisTitle = report.settings.axisTitle || { x: {}, y: {}, z: {} }
    report.settings.axisSettings = report.settings.axisSettings || { y: {} }
    report.settings.groupBySettings = report.settings.groupBySettings
    report.settings.truncateSettings = report.settings.truncateSettings
    report.settings.fillMissingDates = report.settings.fillMissingDates || false
    //setReportDetails({ reportDetails: report })
    this.setState({reportListPopup: false, tabReports: [], exportCsv: true, reportObjToDownload: report})
  }

  setExportCsv = (val) => {
    this.setState({exportCsv: val,reportObjToDownload: null})
  }

  handleCloseEnlargeView = () => {
    this.setState({ openEnlargeViewPopup: false, enlargeViewObj: {} })
  }

  handleReportMoreMenuClick = (e, i) => {
    e.preventDefault();
    if (e.target != this.state.reportMoreMenuEl) {
      this.setState({
        reportMoreMenuId: i,
        reportMoreMenuEl: e.target,
      });
    } else {
      this.handleReportMoreMenuClose();
    }

  };

  handleReportMoreMenuClose = () => {
    // console.log("out");
    this.setState({
      reportMoreMenuId: null,
      reportMoreMenuEl: null,
    });
  };

  updateReportDetails = (selectedReports) => {
    this.setState({ selectedReports: selectedReports });
  }

  updateLinkedReportDetails = async (selectedReports, reportId) => {
    const reportIndex = selectedReports.findIndex(report => report._id === reportId);
    const report = await this.applyFilterOnLinkedReports(selectedReports[reportIndex]);
    selectedReports[reportIndex] = { ...report };
    this.setState({ selectedReports: selectedReports });
  };

  generateFilterMenu = (filters, reportIndex) => {
    let Menus = []
    const reportDetails = this.props?.selectedReports

    filters.map((obj, index) => {
      let { listType, operator, displayName } = obj
      let propObj = {
        i: index,
        reportIndex,
        filterCondtion: obj,
        handleChangeFilterFromList: this.handleChangeFilterFromList,
        reportDetails: reportDetails,
        from: 'dashboard',
        updateReportDetails: this.updateReportDetails
      }

      let dateFilterProps = {
        i: index,
        reportIndex,
        obj,
        handleDateFilter: this.handleChangeDateFilterFromList,
      }

      if (listType && operator === "equals") {
        Menus.push({
          label: (
            <FormControl variant="outlined" sx={{ m: 1, width: 120 }}>
              <InputLabel size='small'> {displayName} </InputLabel>
              {listType === "dropdown" ? <FilterSelectValue {...propObj} /> : <FilterMultipleSelectValue {...propObj} />}
            </FormControl>
          ),
          func: () => { }
        })
      }
      else if (operator === "inDateRange" || operator === "notInDateRange") {
        Menus.push({
          label: (<FilterDateRange {...dateFilterProps} />),
          func: () => { }
        })
      }
      else if (operator === "beforeDate" || operator === "afterDate") {
        Menus.push({
          label: (<FilterSingleDate {...dateFilterProps} />),
          func: () => { }
        })
      }
      else {
        Menus.push(null)
      }
    })

    return Menus
  }

  handleReportClick = (e, report, index) => {
    e.stopPropagation()
    if (report && report?.linkedTo) {
      let eleCard = document.querySelector(`#report-${report?.linkedTo?.reportId}`);

      if (eleCard) {
        eleCard.classList.add('dash-report-highlight');
        eleCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => {
          eleCard.classList.remove('dash-report-highlight');
        }, 5000)
      }
    }
  }


  convertToTable = (l) => {
    let { toggledToTable } = this.state
    toggledToTable[l?._id] = !toggledToTable?.[l?._id]
    this.setState(toggledToTable)
  }


  viewLinkedReport = (e, newValue, l) => {
    let { reportsTabsView } = this.state
    reportsTabsView[l?._id] = newValue
    this.setState({ reportsTabsView })
  }



  generateDOM = () => {
    let { selectedReports, dimensionTitle, measureTitle, isTitlePopup, toggledToTable, reportsTabsView } = this.state;
    const layout = this.generateLayout(selectedReports);


    const handleDeleteSection = (report) => {
      this.props.handleRemoveSection(report);
      this.setState({ deleteSectionModalStatus: false });
    }

    return _.map(layout, (l, i) => {
      let { settings, chartType, linkedReports, linkedReportsViewType, linkedReportsViewCount, linkedReportsViewCountMobile } = l
      l.backgroundColor = COLORS_SERIES[(i % COLORS_SERIES.length)]

      let reportBgColor;
      let reportGridBgColor;
      let reportBorderColor;
      let reportHasBorder;
      let reportHasCarouselElevation;
      //let reportIsCarouselCardTitle;
      let reportCarouselCardSpacing;
      let reportCarouselElevationColor;
      let reportHasCarouselCardElevation;
      let reportCarouselCardElevationColor;
      let reportHasBgColor;
      let reportHasBackgroundStyling;
      let reportShowBorderForHeading;

      if (isMobileView()) {
        reportGridBgColor = settings?.mobile?.reportShowGridBackgroundColor ? settings?.mobile?.reportGridBgColor : null;
        reportHasBgColor = settings?.mobile?.reportShowBackgroundColor;
        reportBgColor = settings?.mobile?.reportShowBackgroundColor ? settings?.mobile?.reportBgColor : null;
        reportBorderColor = settings?.mobile?.reportShowBorderColor ? settings?.mobile?.reportBorderColor : null;
        reportHasBorder = settings?.mobile?.reportShowBorderColor;
        reportHasCarouselElevation = settings?.mobile?.reportIsCarouselElevation || 0;
        reportCarouselElevationColor = settings?.mobile?.reportIsCarouselElevation ? settings?.mobile?.reportCarouselElevationColor : null;
        //reportIsCarouselCardTitle = settings?.mobile?.reportIsCarouselCardTitle;
        reportCarouselCardSpacing = settings?.mobile?.reportCarouselCardSpacing || '0';
        reportHasCarouselCardElevation = settings?.mobile?.reportIsCarouselCardElevation || 0;
        reportCarouselCardElevationColor = settings?.mobile?.reportIsCarouselCardElevation ? settings?.mobile?.reportCarouselCardElevationColor : null;
        reportShowBorderForHeading = settings?.mobile?.reportShowBorderForHeading;
      } else {
        reportGridBgColor = settings?.web?.reportShowGridBackgroundColor ? settings?.web?.reportGridBgColor : null;
        reportHasBgColor = settings?.web?.reportShowBackgroundColor;
        reportBgColor = settings?.web?.reportShowBackgroundColor ? settings?.web?.reportBgColor : null;
        reportBorderColor = settings?.web?.reportShowBorderColor ? settings?.web?.reportBorderColor : null;
        reportHasBorder = settings?.web?.reportShowBorderColor;
        reportHasCarouselElevation = settings?.web?.reportIsCarouselElevation || 0;
        reportCarouselElevationColor = settings?.web?.reportIsCarouselElevation ? settings?.web?.reportCarouselElevationColor : null;
        //reportIsCarouselCardTitle = settings?.web?.reportIsCarouselCardTitle;
        reportCarouselCardSpacing = settings?.web?.reportCarouselCardSpacing || '0';
        reportHasCarouselCardElevation = settings?.web?.reportIsCarouselCardElevation || 0;
        reportCarouselCardElevationColor = settings?.web?.reportIsCarouselCardElevation ? settings?.web?.reportCarouselCardElevationColor : null;
        reportShowBorderForHeading = settings?.web?.reportShowBorderForHeading;
      }

      reportHasBackgroundStyling = (!!reportHasBgColor || !!reportHasBorder || !!reportHasCarouselElevation);
      let isFilters = false;
      l?.reportFilters?.every(item => {
        isFilters = (item?.listType && item?.operator && !item.hidden) ? true : false;
        if (isFilters) return false;
        else return true;
      });
      if (l?.reportType === 'section') {
        return <Box mb={4} mt={4} className="section_box re-reports-manage-section" key={l?.id} data-grid={l} data-id={l?.id}>
          <Grid mb={2} className="re-reports-manage-section-box" >
            <Grid className="sheet-container re-reports-manage-container" justifyContent="flex-between">
              <Grid className="re-reports-manage-section-content">
                <Box className="re-reports-manage-section-content-inner">
                  <Typography variant="h6" className="ed-report-title section-title"> {handleLanguageChange(l?.reportName)} </Typography>
                  {
                    l?.description
                      ? <Typography variant="subtitle2" className="ed-report-subtitle section-description">
                        <span dangerouslySetInnerHTML={{ __html: l?.description }} />
                        {/* {handleLanguageChange(l?.description)}  */}
                      </Typography>
                      : null
                  }
                </Box>
                {
                  l?.hasHRLine
                    ? <Box className="re-reports-manage-section-content-line"><hr /></Box>
                    : null
                }

              </Grid>
              <Grid className="re-reports-manage-section-actions">
                <MButton title='Edit Section'>
                  <EditIcon onClick={e => this.props.handleEditSection(l)} />
                </MButton>
                <MButton title='Delete Section'>
                  <DeleteIcon onClick={e => this.setState({ deleteSectionModalStatus: true })} />
                </MButton>
              </Grid>
            </Grid>
          </Grid>

          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal-root re-modal"
            open={this.state.deleteSectionModalStatus}
            closeAfterTransition
          >
            <Fade in={this.state.deleteSectionModalStatus}>
              <Box className="modal-paper modal-box modal-xs" id="transition-modal-title">

                <Box className="modal-content">
                  <Typography className="re-modal-xs-title">Delete Section</Typography>
                  <IconButton className="re-modal-xs-action-icon" ><DeleteLgIcon /></IconButton>
                  <Typography className="re-modal-xs-action-txt">Are you sure you want to delete this section?</Typography>
                  <Box className="re-modal-xs-action-items">
                    <Button className="re-modal-xs-action-cancel-btn" onClick={e => this.setState({ deleteSectionModalStatus: false })} text="No" />
                    <Button className="re-modal-xs-action-submit-btn" onClick={e => handleDeleteSection(l)} text="Yes" />
                  </Box>
                </Box>

              </Box>
            </Fade>
          </Modal>


        </Box>
      }
      else {

        if (l.chartType === 'numberGraphicCard' && linkedReports?.length) {
          return <Stack key={l.i} data-grid={l} id={`report-${l?._id}`} className={`number_chart_card report_number_chart_box ` + ` report_number_carousel_chart `
            + (reportBgColor ? ` has-bg ` : ``)
            + (reportHasBackgroundStyling ? ` has-bg-style` : ``)
          }  >
            <Box className={`report_chart_box_wrapper ` + settings?.numberChartTemplate?.template + ` ` + ((reportBgColor) ? ` has-bg ` : ``) 
              + ((reportHasBorder) ? ` has-border ` : ``) + ((reportHasCarouselElevation) ? ` has-elevation ` : ``)}
              sx={{ backgroundColor: (reportBgColor ? reportBgColor : 'transparent'), borderWidth: (reportHasBorder ? '1px' : '0px'), 
              borderStyle: 'solid', borderColor: reportBorderColor ? reportBorderColor : 'transparent', width: '100%' }} >
              <Box className={`chart-carousel ` + (isMobileView() ? 'chart-carousel-mobile' : ``)}
                sx={{ width: '100%', height: '100%' }}>
                {
                  (settings?.numberChartTemplate?.template === 'template2')
                    ? <Box className={(reportShowBorderForHeading ? `report-heading-has-border` : ``)}>
                      <Box className='number_chart_carousel_heading'>
                        <Typography variant="h6" className="number_chart_carousel_title" title={handleLanguageChange(l?.reportName)}
                        >{handleStringLength(handleLanguageChange(l?.reportName), NumberChartTitleLength)}</Typography>
                        <Typography variant="body2" className="number_chart_carousel_subtitle" title={handleLanguageChange(l?.description)}
                        >{handleStringLength(handleLanguageChange(l?.description), NumberChartDescriptionLength)}</Typography>
                      </Box>
                    </Box>
                    : null
                }
                
                <Box className={`re-carousel-wrapper ` + l?.chartType}>
                  <Swiper
                    // ref={slider => {
                    //   if (!this.state.chartRefs[l?.i]?.current) {
                    //     let stateRefs = this.state.chartRefs;
                    //     stateRefs[l?.i] = { current: slider };
                    //     this.setState({ chartRefs: stateRefs });
                    //   }

                    // }}
                    spaceBetween={parseInt(reportCarouselCardSpacing)}
                    // slidesPerView={((settings?.numberChartTemplate?.template === 'template2')
                    //     ? ((this.state.chartContainerWidth - 80) / (215 + (reportHasCarouselCardElevation ? 40 : 0)))
                    //     : (settings?.numberChartTemplate?.template === 'template6')
                    //       ? ((this.state.chartContainerWidth - 80) / ((210 + (reportHasCarouselCardElevation ? 40 : 0))))
                    //       : (isMobileView() ? linkedReportsViewCountMobile : linkedReportsViewCount)
                    //   ) ?? 1}
                    slidesPerView="auto"
                    modules={[Navigation]}
                    navigation={isMobileView() ? false : {
                      prevEl: `${'.swiper-prev-arrow' + l?.i}`,
                      nextEl: `${'.swiper-next-arrow' + l?.i}`,
                    }}
                    >
                      <SwiperSlide key={l?._id} >
                        <ReportGraph key={l?._id} reportDetails={CubeReqMapper(l, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this.props.renewCache)} openToolBar={false} />
                      </SwiperSlide>

                      {linkedReports?.map((reportObj, linkedRpIndex) => (
                        <SwiperSlide key={linkedRpIndex}>
                          <ReportGraph reportDetails={CubeReqMapper({
                            ...reportObj?.reportId, toggleToTable: toggledToTable[l?._id],
                            backgroundColor: COLORS_SERIES[(linkedRpIndex + 1 % COLORS_SERIES.length)],
                            carouselName: reportObj?.carouselName,
                            carouselDescription: reportObj?.carouselDescription,
                          },
                            [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this?.props?.renewCache)} openToolBar={false} />
                            </SwiperSlide>
                          ))}
                  </Swiper>
                  {
                    isMobileView() 
                      ? null
                      : <>
                          <IconButton className={`swiper-nav-arrow er-slide-left-nav swiper-prev-arrow` + l?.i}><LeftNavIcon /></IconButton>
                          <IconButton  className={`swiper-nav-arrow er-slide-right-nav swiper-next-arrow` + l?.i }><RightNavIcon /></IconButton>
                        </>
                  }
                </Box>
              </Box>
            </Box>
          </Stack>
        }

        if (l.chartType === 'number' && !linkedReports?.length) {
          return (
            <Card key={l.i} data-grid={l} variant="outlined" className="number_chart_card report-number-card-metrics number_chart_card_metrics"
            //style={{ background: COLORS_SERIES[(i % COLORS_SERIES.length)] }} 
            >
              {/* <Typography variant="h6" className="number_chart_title">{handleLanguageChange(l.reportName)}</Typography> */}
              <Box className="width-100" > {/* removed className 'number_chart_value' for issue rte-2393 */}
                {l._id && (<ReportGraph reportDetails={CubeReqMapper(l, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this.props.renewCache)} openToolBar={false} />)}
              </Box>
              {/* <Typography variant="body2" className="number_chart_subtitle">{handleLanguageChange(l.description)}</Typography> */}
            </Card>
          )
        }

        if (l.chartType === 'number' && linkedReports?.length) {
          return <Stack key={l.i} data-grid={l} id={`report-${l?._id}`} className={`number_chart_card_carousel ` + ` report_number_carousel_chart `
            + (reportBgColor ? ` has-bg ` : ``)
            + (reportHasBackgroundStyling ? ` has-bg-style` : ``)
            + ` ` + settings?.numberChartTemplate?.template
          }  >
            <Box className={`report_chart_box_wrapper ` + settings?.numberChartTemplate?.template + ` `
              + ((reportBgColor) ? ` has-bg ` : ``)
              + ((reportHasBorder) ? ` has-border ` : ``)
              + ((reportHasCarouselElevation) ? ` has-elevation ` : ``)
              + ((reportHasCarouselCardElevation) ? ` has-card-elevation ` : ``)}
              sx={{
                backgroundColor: (reportBgColor ? reportBgColor : 'transparent'),
                borderWidth: (reportHasBorder ? '1px' : '0px'),
                borderStyle: 'solid',
                borderColor: reportBorderColor ? reportBorderColor : 'transparent',
                boxShadow: (reportHasCarouselElevation ? `0px 0px 6px ${reportCarouselElevationColor ?? '#DEDEDE'}` : 'none'),
              }}
            >
              <Box className={`chart-carousel ` + (isMobileView() ? 'chart-carousel-mobile' : ``) + reportHasBackgroundStyling}
                sx={{ width: '100%', height: '100%' }}>

                <Box className={(reportShowBorderForHeading ? `report-heading-has-border` : ``)}
                  sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'start',
                  }}
                >
                  <Box>
                    <Box className='number_chart_carousel_heading'>
                      <Typography variant="h6" className="number_chart_carousel_title" title={handleLanguageChange(l?.reportName)}
                      >{handleStringLength(handleLanguageChange(l?.reportName), NumberChartTitleLength)}</Typography>
                      <Typography variant="body2" className="number_chart_carousel_subtitle" title={handleLanguageChange(l?.description)}
                      >{handleStringLength(handleLanguageChange(l?.description), NumberChartDescriptionLength)}</Typography>
                    </Box>
                  </Box>
                  <Box>
                    {isFilters ? <ReportFilterMenu
                      icon={<FilterIcon />}
                      report={l}
                      reportIndex={i}
                      updateReport={this.updateReport}
                    /> : null}
                  </Box>
                </Box>

                
                 <Box className={`re-carousel-wrapper ` + l?.chartType}>
                  <Swiper
                    // ref={slider => {
                    //   if (!this.state.chartRefs[l?.i]?.current) {
                    //     let stateRefs = this.state.chartRefs;
                    //     stateRefs[l?.i] = { current: slider };
                    //     this.setState({ chartRefs: stateRefs });
                    //   }

                    // }}
                    spaceBetween={parseInt(reportCarouselCardSpacing)}
                    // slidesPerView={((settings?.numberChartTemplate?.template === 'template2')
                    //     ? ((this.state.chartContainerWidth - 80) / (215 + (reportHasCarouselCardElevation ? 40 : 0) + parseInt(reportCarouselCardSpacing)))
                    //     : (settings?.numberChartTemplate?.template === 'template6')
                    //       ? ((this.state.chartContainerWidth - 80) / ((210 + (reportHasCarouselCardElevation ? 40 : 0)) + parseInt(reportCarouselCardSpacing)))
                    //       : (isMobileView() ? linkedReportsViewCountMobile : linkedReportsViewCount)
                    //   ) ?? 1}
                    slidesPerView="auto"
                    modules={[Navigation]}
                    navigation={isMobileView() ? false : {
                      prevEl: `${'.swiper-prev-arrow' + l?.i}`,
                      nextEl: `${'.swiper-next-arrow' + l?.i}`,
                    }}
                    >
                      <SwiperSlide key={l?._id} >
                        <Card id={`report-${l?._id}`} onClick={e => this.handleReportClick(e, l, l.i)} data-grid={l} variant="outlined"
                          className={"number_chart_card " + settings?.numberChartTemplate?.template} >
                          <Box className="" sx={{ boxShadow: `0px 0px 4px ${reportHasCarouselCardElevation ? (reportCarouselCardElevationColor ?? '#DEDEDE') : 'none'}` }}>
                            <Box className="number_chart_card_heading">
                              {
                                l?.carouselName ?
                                  <Typography variant="h6" className="number_chart_title" title={handleLanguageChange(l?.carouselName)}
                                  >{handleStringLength(handleLanguageChange(l?.carouselName), NumberChartTitleLength)}</Typography>
                                  : null
                              }
                              {
                                l?.carouselDescription ?
                                  <Typography variant="body2" className="number_chart_subtitle" title={handleLanguageChange(l?.carouselDescription)}
                                  >{handleStringLength(handleLanguageChange(l?.carouselDescription), NumberChartDescriptionLength)}</Typography>
                                  : null
                              }
                            </Box>
                            <Box className="number_chart_value" >
                              {l._id && (<ReportGraph reportDetails={CubeReqMapper(l, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this?.props?.renewCache)} openToolBar={false} />)}
                            </Box>
                          </Box>
                        </Card>
                      </SwiperSlide>

                      {linkedReports?.map((reportObj, linkedRpIndex) => (
                        <SwiperSlide key={linkedRpIndex}>
                          <Card id={`report-${reportObj?.reportId?._id}`} key={linkedRpIndex} data-grid={l} variant="outlined" className={"number_chart_card " + settings?.numberChartTemplate?.template} >
                            <Box className="" sx={{ boxShadow: `0px 0px 4px ${reportHasCarouselCardElevation ? (reportCarouselCardElevationColor ?? '#DEDEDE') : 'none'}` }}>
                              <Box>
                                {
                                  reportObj?.carouselName ?
                                    <Typography variant="h6" title={handleLanguageChange(reportObj?.carouselName)} className="number_chart_title"
                                    >{handleStringLength(handleLanguageChange(reportObj?.carouselName), NumberChartTitleLength)}</Typography>
                                    : null
                                }
                                {
                                  reportObj?.carouselDescription ?
                                    <Typography variant="body2" className="number_chart_subtitle" title={reportObj?.carouselDescription}
                                    >{handleStringLength(reportObj?.carouselDescription, NumberChartDescriptionLength)}</Typography>
                                    : null
                                }
                              </Box>


                              <Box className="number_chart_value" >
                                <ReportGraph reportDetails={CubeReqMapper({
                                  ...reportObj?.reportId, toggleToTable: toggledToTable[reportObj?._id],
                                  carouselName: reportObj?.carouselName,
                                  carouselDescription: reportObj?.carouselDescription,
                                }, [{ ...measureTitle[reportObj?._id], ...dimensionTitle[reportObj?._id] }], this?.props?.renewCache)}
                                  openToolBar={false} />
                              </Box>

                            </Box>
                          </Card>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                    {
                      isMobileView() 
                        ? null
                        : <>
                            <IconButton className={`swiper-nav-arrow er-slide-left-nav swiper-prev-arrow` + l?.i}><LeftNavIcon /></IconButton>
                            <IconButton  className={`swiper-nav-arrow er-slide-right-nav swiper-next-arrow` + l?.i }><RightNavIcon /></IconButton>
                          </>
                    }
                  </Box>
              </Box>
            </Box>
          </Stack>
        }
      }

      return (
        <Box key={l.i} data-grid={l} onClick={e => this.handleReportClick(e, l, l.i)} className={`report_chart_box `
          + (reportBgColor ? ` has-bg ` : ` `)
          + ((reportHasBorder) ? ` has-border ` : ` `)
          + (l?.comparisonChartType ? ' is-comparison-chart ' : ``)
          + (l?.quickFilterList?.length > 0 ? ' is-quick-chart ' : ``)
          + (((l?.comparisonChartType || (l?.quickFilterList?.length > 0)) && reportGridBgColor) ? ` dash-report-has-grid-styling ` : ` `)
          + ((l?.linkedReports?.length > 0 && (linkedReportsViewType === 'CAROUSEL')) ? ` dash-report-has-linked-reports ` : ` `)

        }
          id={`report-${l?._id}`}
        >
          <Box className="report_chart_box_wrapper"
            sx={{
              backgroundColor: (reportBgColor ? reportBgColor : 'transparent'),
              borderWidth: (reportHasBorder ? '1px' : '0px'),
              borderStyle: 'solid', borderColor:
                reportBorderColor ? reportBorderColor : '#dedede'
            }} >

            {
              ((l?.quickFilterList?.length > 0) ? false : !l?.comparisonChartType)
                ?
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-start"
                  spacing={2}
                  className={`grid_drag dashboard-report-heading `
                    + ((reportShowBorderForHeading) ? (((toggledToTable[l?._id] || (l?.chartType === 'table'))) ? `` : ` report-heading-has-border`) : ``)
                  }
                >
                  <Box>
                    <Grid container className={`dash-report-header-container ` + l.chartType} >
                      <Grid item xs={12}>
                        <Typography variant="h6" className="ed-report-title" title={handleLanguageChange(l?.reportName)}
                        > {handleStringLength(handleLanguageChange(l?.reportName), ReportCardTitleLength)} </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle2" className="ed-report-subtitle" title={handleLanguageChange(l?.description)}
                        > {handleStringLength(handleLanguageChange(l?.description), ReportCardDescriptionLength)} </Typography>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box className={"grid_header_icons ed-report-icons "
                    + ((l?.comparisonChartType || l?.quickFilterList?.length > 0) ? ` dash-report-has-no-header` : ``)
                    + (!!reportGridBgColor ? ` dash-report-header-has-grid-bg ` : ` `)
                  }>
                    {settings?.showTogleToTable && chartType !== 'table' ?
                      <MButton onClick={() => this.convertToTable(l)} title='Toggle View'>
                        {toggledToTable[l?._id] ? <GraphIcon /> : <TableIcon />}
                      </MButton> : null}

                      {
                        l?.downloadFlag && <>
                            <IconButton className="grid_header_icon_enlarge red form-icon-btn 11" onClick={() => this.downloadReport(l)} >
                              <FileDownloadOutlinedIcon />
                            </IconButton>                            
                        </>                        
                      } 
                    <IconButton className="form-icon-btn" onClick={() => this.enlargeChart(l)} >
                      <ResizeIcon />
                    </IconButton>

                    {l?.reportFilters?.filter(filterObj => filterObj?.listType !== undefined)?.length ?
                      <>
                        {isFilters ? <ReportFilterMenu
                          icon={<FilterIcon />}
                          report={l}
                          reportIndex={i}
                          updateReport={this.updateReport}
                          selectedReports={this.state.mainSelectedReports}
                          reportsTabsView={this.state.reportsTabsView}
                        /> : null}
                      </>
                      : null}

                    <ReportMenu icon={<MoreIcon />}
                      onClose={() => { }}
                      shouldCloseOnClick={false}
                      options={[
                        { label: 'Settings', func: (e) => this.toggleTitlePopup(e, true, l?._id), className: "menu-item" },
                        {
                          label: LimitAllowedIn.includes(l.chartType) ? (<Limit limitValue={l.limit} index={i} handleReportLimit={this.handleReportLimit} />) : null,
                          func: () => { }, className: "menu-item-single"
                        }
                      ]}
                    />
                  </Box>
                </Stack>
                : null
            }

            {linkedReportsViewType === 'CAROUSEL' ?
              <Stack className="grid_drag inherit-height">
                <Box className={`chart-carousel ` + (isMobileView() ? 'chart-carousel-mobile' : ``)} sx={{ width: '100%', height: '100%' }}>
                  {/* <Box className={((reportShowBorderForHeading) ? (((toggledToTable[l?._id] || (l?.chartType === 'table') )) ?  `` : ` report-heading-has-border`) : ``)}>
                    <Box className='number_chart_carousel_heading'>
                      <Typography variant="h6" className="number_chart_carousel_title" title={handleLanguageChange(l?.reportName)}
                      >{handleStringLength(handleLanguageChange(l?.reportName), NumberChartTitleLength)}</Typography>
                      <Typography variant="body2" className="number_chart_carousel_subtitle" title={handleLanguageChange(l?.description)}
                      >{handleStringLength(handleLanguageChange(l?.description), NumberChartDescriptionLength)}</Typography>
                    </Box>
                  </Box> */}
                  <Box className={`re-carousel-wrapper ` 
                    + (!(l?.chartType === 'number' || l?.chartType === 'numberGraphicCard') ? `non-number-chart` : ``)}
                  >
                    <Swiper
                      // ref={slider => {
                      //   if (!this.state.chartRefs[i]?.current) {
                      //     let stateRefs = this.state.chartRefs;
                      //     stateRefs[i] = { current: slider };
                      //     this.setState({ chartRefs: stateRefs });
                      //   }

                      // }}
                      spaceBetween={parseInt(reportCarouselCardSpacing)}
                      slidesPerView={(isMobileView() ? linkedReportsViewCountMobile : linkedReportsViewCount) ?? 1}
                      modules={[Navigation]}
                      navigation={isMobileView() ? false : {
                        prevEl: `${'.swiper-prev-arrow' + l?.i}`,
                        nextEl: `${'.swiper-next-arrow' + l?.i}`,
                      }}
                      onSwiper={(swiper) => {
                        // setTimeout(() => {
                        //   if ((l?.linkedReports?.length > 0) && (l?.linkedReportsViewType === 'CAROUSEL')) {
                        //     const trackOfcarouselEl = this.state.chartRefs[i]?.current?.innerSlider?.list?.querySelector('.slick-track');
                        //     if (trackOfcarouselEl) trackOfcarouselEl.style.height = (((l?.h * 10) + (l?.h - 1) * 20) - 84 - (l?.description ? 19 : 0)) + 'px';
                        //   }
                        // }, [1000])
                      }}
                    >
                      <SwiperSlide key={l?._id} >
                        <Box className="carousel_card" >
                          <Grid container mb={2} >
                            <Grid item xs={12}>
                              <Typography variant="h6" className="ed-report-title" title={handleLanguageChange(l?.carouselName)}
                              > {handleStringLength(handleLanguageChange(l?.carouselName), NumberChartTitleLength)} </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant="subtitle2" className="ed-report-subtitle" title={handleLanguageChange(l?.carouselDescription)}
                              > {handleStringLength(handleLanguageChange(l?.carouselDescription), NumberChartDescriptionLength)} </Typography>
                            </Grid>
                          </Grid>
                          <ReportGraph reportOfLinkedType={linkedReportsViewType} hasLinkedReports={(l?.linkedReports?.length > 0) ? true : false} reportIn="dashboard" h={l?.h}
                            reportDetails={CubeReqMapper({ ...l, toggleToTable: toggledToTable[l?._id] }, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this.props.renewCache)} openToolBar={false} />
                        </Box>
                      </SwiperSlide>

                      {linkedReports?.map((reportObj, ind) => (
                        <SwiperSlide key={ind} >
                          <Box className="carousel_card">
                            <Grid container mb={2} >
                              <Grid item xs={12}>
                                <Typography variant="h6" className="ed-report-title" title={handleLanguageChange(reportObj?.carouselName)}
                                > {handleStringLength(handleLanguageChange(reportObj?.carouselName), NumberChartTitleLength)} </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Typography variant="subtitle2" className="ed-report-subtitle" title={handleLanguageChange(reportObj?.carouselDescription)}
                                > {handleStringLength(handleLanguageChange(reportObj?.carouselDescription), NumberChartDescriptionLength)} </Typography>
                              </Grid>
                            </Grid>
                            <ReportGraph reportOfLinkedType={linkedReportsViewType} hasLinkedReports={(l?.linkedReports?.length > 0) ? true : false} reportIn="dashboard" h={l?.h}
                              reportDetails={CubeReqMapper({
                                ...reportObj?.reportId, toggleToTable: toggledToTable[l?._id], carouselName: reportObj?.carouselName, carouselDescription: reportObj?.carouselDescription
                              }, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this.props.renewCache)}
                              openToolBar={false} />
                          </Box>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                    {
                      isMobileView()
                        ? null
                        : <>
                          <CarouselPrevArrow className="swiper-nav-arrow swiper-prev-arrow" />
                          <CarouselNextArrow className="swiper-nav-arrow swiper-next-arrow" />
                        </>
                    }
                  </Box>
                </Box>
              </Stack>

              : <>
                <Stack>
                  {linkedReports?.length ? <Tabs
                    value={reportsTabsView?.[l?._id] ?? 0}
                    onChange={(e, newValue) => this.viewLinkedReport(e, newValue, l)}
                    sx={{ mb: 2 }}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="wrapped label tabs example"
                    className="dash-report-has-tabs"
                    TabIndicatorProps={{
                      sx: {
                        backgroundColor: 'transparent',
                      },
                      children: <span />
                    }}
                  >
                    <Tab className="sheet-item" value={0} label={l?.tabName ? l?.tabName : l?.reportName} />
                    {linkedReports?.map((reportObj, i) => (
                      <Tab key={i} className="sheet-item" value={i + 1} label={reportObj?.tabName ? reportObj?.tabName : reportObj?.reportName} />
                    ))}
                  </Tabs> : null}
                </Stack>

                <Stack className={`grid_drag inherit-height ` + ((l?.quickFilterList?.length > 0) ? ` is-quick-chart ` : ` `)
                  + (l?.comparisonChartType ? ` is-comparison-chart ` : ` `)
                  + (l?.description ? `` : ` dash-report-header-has-no-description`)
                } >
                  {reportsTabsView?.[l?._id] > 0 ?
                    <ReportGraph reportOfLinkedType={linkedReportsViewType} hasLinkedReports={(l?.linkedReports?.length > 0) ? true : false} reportIn="dashboard" h={l?.h}
                      reportDetails={CubeReqMapper({
                        ...linkedReports?.[reportsTabsView?.[l?._id] - 1]?.reportId, toggleToTable: toggledToTable[l?._id]
                      }, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this.props.renewCache)} openToolBar={false} /> :

                    <ReportGraph reportOfLinkedType={linkedReportsViewType} hasLinkedReports={(l?.linkedReports?.length > 0) ? true : false} reportIn="dashboard" h={l?.h}
                      reportDetails={CubeReqMapper({ ...l, toggleToTable: toggledToTable[l?._id] }, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], this.props.renewCache)} openToolBar={false} />
                  }
                </Stack>
              </>}

            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className="modal-root"
              open={isTitlePopup[l?._id] ?? false}
              closeAfterTransition
            >
              <Fade in={isTitlePopup[l?._id]}>
                <Box className="modal-paper modal-box modal-md" id="transition-modal-title">
                  <Box className="modal-header" sx={{ pl: '2.5rem', pr: '2.5rem' }} >
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="subtitle1" className=" modal-header-title folder-modal-title pl-0" >{`Settings`}</Typography>
                      <IconButton onClick={(e) => this.handleCLoseTitlePopup(e, l?._id)} className="form-icon-btn" color="secondary">
                        <img src={CloseIcon} alt='' />
                      </IconButton>
                    </Box>
                  </Box>
                  <Box className="modal-content my-0 text-left" sx={{ maxHeight: "500px", overflow: 'auto' }}>
                    <Accordion onChange={e => this.onAccordianChange(e)}>
                      <AccordionSummary
                        className="my-0 pl-0"
                        expandIcon={<IconAngleDown />}
                        id="labelSettings"
                      >
                        <Typography variant="h6" className="font-weight-500 my-0">Label Settings</Typography>
                      </AccordionSummary>

                      <AccordionDetails className="text-left chart_settings_details" >
                        <Grid container className="title_popup_wrapper" spacing={2}>
                          {l?.dimensions?.map((dim, i) => {
                            return (
                              <Grid item xs={12} key={i}>
                                <Typography className="form_input_label" variant="subtitle1">

                                  {dim?.displayName ||
                                    CamelToNormalString(
                                      dim?.fieldName?.split(".")?.[1]
                                    )}
                                </Typography>
                                <Input
                                  className="title_setting_input report_form_ui_input"
                                  id={dim?.fieldName}
                                  value={
                                    dimensionTitle[l?._id]
                                      ? dimensionTitle[l?._id][dim?.fieldName]
                                      : ""
                                  }
                                  onChange={(e) =>
                                    this.handleDimensionTitleChange(e, dim, l, l?._id)
                                  }
                                />
                              </Grid>
                            );
                          })}{" "}
                          {l?.measures?.map((meas, i) => {
                            return (
                              <Grid container item xs={12} key={i} >
                                <Typography className="form_input_label" variant="subtitle1">
                                  {
                                    meas?.displayName ||
                                    CamelToNormalString(
                                      meas?.fieldName?.split(".")?.[1]
                                    )}
                                </Typography>
                                <Input
                                  className="title_setting_input report_form_ui_input"
                                  id={meas?.fieldName}
                                  value={
                                    measureTitle[l?._id]
                                      ? measureTitle[l?._id][meas?.fieldName]
                                      : ""
                                  }
                                  onChange={(e) =>
                                    this.handleMeasureTitleChange(e, meas, l, l?._id)
                                  }
                                />

                              </Grid>
                            );
                          })}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    <Accordion onChange={e => this.onAccordianChange(e)}>
                      <AccordionSummary
                        className="my-0 pl-0"
                        expandIcon={<IconAngleDown />}
                        id="legendSettings"
                      >
                        <Typography variant="h6" className="font-weight-500">Legend Settings</Typography>
                      </AccordionSummary>
                      <AccordionDetails className="text-left chart_settings_details">
                        <Grid container className="title_popup_wrapper" spacing={2}>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  onChange={(e) => this.handleLegendVisibility(e, l, i)}
                                  checked={l?.isLegendVisible}
                                />
                              }
                              label="Legends Visibility"
                            />

                            <FormControl>
                              <Typography variant="subtitle1" className="form_input_label">Legend Settings</Typography>
                              <Select
                                size="small"
                                value={l?.legendPosition || ""}
                                onChange={(e) => this.handleLegendPosition(e, l, i)}
                                className="report_form_ui_input_select pl-0"
                                IconComponent={IconAngleDown}
                              >
                                <MenuItem value={"right"}>Right</MenuItem>
                                <MenuItem value={"bottom"}>Bottom</MenuItem>
                              </Select>
                            </FormControl>
                          </FormGroup>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion onChange={e => this.onAccordianChange(e)}>
                      <AccordionSummary
                        className="my-0 pl-0"
                        expandIcon={<IconAngleDown />}
                        id="legendSettings"
                      >
                        <Typography variant="h6" className="font-weight-500">Report Linking</Typography>
                      </AccordionSummary>
                      <AccordionDetails className="text-left chart_settings_details">
                        <Grid container className="title_popup_wrapper" spacing={2}>
                          <FormGroup>
                            <FormControl>
                              <Typography variant="subtitle1" className="form_input_label">Select Report</Typography>
                              <Select
                                size="small"
                                value={l?.linkedTo?.reportName}
                                onChange={(e) => this.handleReportLinking(e, l, i)}
                                className="report_form_ui_input_select pl-0"
                                IconComponent={IconAngleDown}
                              >
                                {
                                  this.state.selectedReports.length &&
                                  this.state.selectedReports.map((report, i) => (
                                    <MenuItem key={i} value={report?.reportName}>{handleLanguageChange(report?.reportName)}</MenuItem>
                                  ))
                                }

                              </Select>
                            </FormControl>
                          </FormGroup>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                  </Box>
                  <Box className="modal-footer text-right" sx={{ p: '1rem 2.5rem', m: '1rem 2.5rem' }}>

                    <Button
                      variant="contained"
                      text="Save"
                      color="primary"
                      size="small"
                      className="title_setting_btn report_form_ui_btn primary"
                      startIcon={<SaveIcon />}
                      onClick={(e) => this.handleSaveTitle(e, l, l?._id, i)}
                    />
                  </Box>
                </Box>
              </Fade>
            </Modal>
          </Box>
        </Box>
      );
    });
  };

  toggleTitlePopup = (e, params, i) => {
    this.state.isTitlePopup[i] = params;
    this.setState({ isTitlePopup: this.state?.isTitlePopup });
  };

  onBreakpointChange = (breakpoint) => {
    this.setState({
      currentBreakpoint: breakpoint,
    });
  };

  onLayoutChange = (layout, layouts) => {
    this.props.onLayoutChange(layout, layouts);
    this.setState({ layouts: layouts });
  };

  onNewLayout = () => {
    let { selectedReports } = this.state;
    this.setState({
      layouts: { lg: this.generateLayout(this.state.selectedReports) },
    });
  };

  generateLayout = (selectedReports) => {
    let newSelectedReports = [...selectedReports];
    let newLayout = _.map(newSelectedReports, (item, i) => {
      const minW = _.random(1, 6);
      const minH = _.random(1, 6);
      const maxW = _.random(minW, 6);
      const maxH = _.random(minH, 6);
      const y = _.random(minH, maxH);

      let defaultWidth = 12
      let defaultHeight = 15

      if (item?.chartType === "numberGraphicCard" || item?.chartType === "number") {
        if (item?.linkedReports?.length) {
          if ((item?.settings?.numberChartTemplate?.template === 'template2') || (item?.settings?.numberChartTemplate?.template === 'template6')) {
            if (!item.h) {
              defaultHeight = 12;
              item.h = 12;
            }
          } else {
            if (!item.h) {
              defaultHeight = 7;
              item.h = 7;
            }

          }
        } else {
          defaultHeight = 7;
        }
      }

      if (item?.reportType === 'section') {
        if (item?.description?.length > 0) {
          item.h = 2.5;
        } else {
          item.h = 2;
        }
      }

      let result = {
        ...item,
        x: item.x || item.x === 0 ? item.x : (i * 2) % 12,
        y: item.y || item.y === 0 ? item.y : Math.floor(i / 6) * y,
        w: item.w ? item.w : defaultWidth,
        h: item.h ? item.h : defaultHeight,
        i: item.i ? item.i : item._id ? item._id.toString() : item.id.toString(),
        ...(item?.reportType === 'section' && { resizeHandles: [], h: item.h ? item.h : 2 })
      };


      return result;
    });
    return newLayout;
  };

  /* componentDidUpdate(prevProps, prevState) {
    console.log('State Change',prevProps, prevState)
  } */
  render() { 
    let { isPublishedDashboardView, exportCsv, reportListPopup, tabReports, reportObjToDownload, openEnlargeViewPopup, enlargeViewObj, measureTitle, dimensionTitle, selectedReports } = this.state;
    let { handleSelectReport } = this.props
    const { classes } = this.props;
    return (
      <>
        {/*<Box sx={{ mb: 2, p: (selectedReports?.length) ? '0' : '0.5rem 0 !important' }} className={classes.tagsContainer + " report-grid-charts tags"}>
          <Box sx={{ overflow: 'overlay', width: '100%', p: '0.5rem 0.5rem !important' }} >
            <List className={classes.tagsList}>
              {selectedReports?.map((obj, i) => (
                <ListItem className="filter-tag-item-box" key={i} sx={{ mr: '0.5rem', px: '0' }} >
                  <Box className="filter-tag-item" >
                    <Typography variant="caption" sx={{ pr: 1, width: "max-content" }}>{handleLanguageChange(obj.reportName)}</Typography>
                    <IconButton onClick={e => handleSelectReport(obj)} ><CancelIcon /></IconButton>
                  </Box>
                </ListItem>
              ))}
            </List>
          </Box>
        </Box>*/}
        <Box className="report-grid-charts charts" id="dashboardWrapper" sx={{ flexGrow: 1 }} ref={this.chartContainerRef} >
          <Responsive
            {...this.props}
            cols={{ lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 }}
            className="layout report_grid_layout re-dashboard-edit-layout"
            layouts={this.state.layouts}
            onBreakpointChange={this.onBreakpointChange}
            onLayoutChange={this.onLayoutChange}
            compactType="vertical"
            isDraggable={!isPublishedDashboardView}
            isResizable={!isPublishedDashboardView}
            draggableCancel="input,button"
            rowHeight={20}
            width={this.state.chartContainerWidth}
          >
            {this.generateDOM()}
          </Responsive>

          {openEnlargeViewPopup ? <ChartEnlargeView chartType={enlargeViewObj?.chartType} reportName={enlargeViewObj?.reportName} openPopup={openEnlargeViewPopup}
            chartIsFiltersType={(enlargeViewObj?.comparisonChartType || enlargeViewObj?.quickFilterList?.length > 0)}
            handleClose={this.handleCloseEnlargeView} ChartComponent={enlargeViewObj._id && (
              <ReportGraph reportIn="dashboard" h={enlargeViewObj?.h}
                reportDetails={CubeReqMapper(enlargeViewObj, [
                  { ...measureTitle[enlargeViewObj?._id], ...dimensionTitle[enlargeViewObj?._id] },
                ], this.props.renewCache)}
                openToolBar={false}
              />
            )} /> : null}

            {
              exportCsv &&  
              <ExportReactCSV reportDetails={{reportDetails:reportObjToDownload}} setExportCsv={this.setExportCsv} setExportProcessDialog={this.setExportCsv} columnTitle={null} columnDisplayName={null}/>
            }
            {

              exportCsv ? <Dialog aria-labelledby="customized-dialog-title" open={exportCsv}>
                <DialogTitle id="customized-dialog-title" >Export in Progress... </DialogTitle>
                <DialogContent dividers>
                  <Typography > We're working to export the report... <CircularProgress /> </Typography>
                </DialogContent>
              </Dialog> : null
            }
            {
              reportListPopup ? <Dialog aria-labelledby="customized-dialog-title" style={{minWidth:"250px"}} open={reportListPopup}>
                <DialogTitle id="customized-dialog-title" >Report Export</DialogTitle>
                <DialogContent dividers>
                  <FormControl>
                    <FormLabel id="demo-controlled-radio-buttons-group">Select Report</FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="controlled-radio-buttons-group"
                      value={reportObjToDownload?._id ?? null}
                      onChange={this.handleSelectReport}
                    >
                      {
                        tabReports.map(tabReport => (
                          <FormControlLabel key={tabReport._id} value={tabReport._id} control={<Radio />} label={tabReport.tabName} />
                        ))
                      }
                    </RadioGroup>
                  </FormControl>
                  <Box>
                    <Button onClick={this.handleExportReport} variant="contained" text={"Export"} color="primary">Export</Button>
                    <Button onClick={this.handleCloseReportListPopup} variant="contained" text="Cancel" color="secondary">Cancel</Button>
                  </Box>
                </DialogContent>
              </Dialog> : null
            }
        </Box>
      </>
    );
  }
}

DashboardChartLayout.propTypes = {
  onLayoutChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};
DashboardChartLayout.defaultProps = {
  rowHeight: 20,
  onLayoutChange: function () { },
  cols: { lg: 12, md: 8, sm: 4, xs: 1, xxs: 1 },
};

export default withStyles(styles)(DashboardChartLayout);
